import React, { createContext, useContext, useEffect, useState } from "react";
import en from "./locales/en";
import id from "./locales/id";
import ru from "./locales/ru";
import zh from "./locales/zh";

const DICT = { en, id, ru, zh };
export const LANGS = [["en", "EN"], ["id", "ID"], ["ru", "RU"], ["zh", "中文"]];

const I18nCtx = createContext({ lang: "en", t: (k) => k, setLang: () => {} });

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const saved = localStorage.getItem("mql_lang");
    return DICT[saved] ? saved : "en";
  });
  useEffect(() => { localStorage.setItem("mql_lang", lang); document.documentElement.lang = lang; }, [lang]);
  const t = (key) => DICT[lang][key] || en[key] || id[key] || key;
  return <I18nCtx.Provider value={{ lang, setLang: setLangState, t }}>{children}</I18nCtx.Provider>;
}

export const useI18n = () => useContext(I18nCtx);
